import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(theme => ({
  chipRoot: {
    borderRadius: '18px',
    padding: theme.spacing(2,3),
    backgroundColor: '',
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center', 
    gap: '4px',
    zIndex:2
  },
  disabledRootChip: {
    backgroundColor: `gray !important`,
    color: `gray !important`
  }
}
));

const Chip = ({ 
  content, color, bgColor, startIcon = null, endIcon = null, sx = {}, disabled,
  typographyVariant = 'body01-bold', ...props 
}) => {
  const classes = useStyles();

  return (
    <Box 
      className={`${classes.chipRoot} ${disabled ? classes.disabledRootChip : ''}`} 
      style={{ backgroundColor: bgColor, color: color, ...sx }} 
      {...props}
    >
      {
        startIcon && startIcon
      }
      <Typography variant={typographyVariant}>
        {content}
      </Typography>
      {
        endIcon && endIcon
      }
    </Box>
  )
}

export default Chip;
